// extracted by mini-css-extract-plugin
export default {"checkbox__wrapper":"baseCheckbox_checkbox__wrapper__YmJJT","checkbox":"baseCheckbox_checkbox__Sm39g","input__label":"baseCheckbox_input__label__wtvQB"};